const sampleTestActions = {
  GET_SAMPLE_QUESTIONS : 'GET_SAMPLE_QUESTIONS',
  SET_SAMPLE_QUESTIONS : 'SET_SAMPLE_QUESTIONS',
  GET_SAMPLE_SUBMIT_ANSWER : 'GET_SAMPLE_SUBMIT_ANSWER',
}

export default sampleTestActions;